import React from 'react';

/** Compact Telnyx provider badge for phone number tables/lists. */
const TelnyxBadge: React.FC<{ className?: string }> = ({ className = '' }) => (
  <span
    className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wide bg-[#00E3AA]/15 text-[#007a5e] dark:text-[#00E3AA] border border-[#00E3AA]/30 ${className}`}
    title="Telnyx"
  >
    <svg viewBox="0 0 24 24" className="h-3 w-3 shrink-0" aria-hidden>
      <circle cx="12" cy="12" r="10" fill="#00E3AA" />
      <path d="M8 12.5l2.5 2.5L16 9" stroke="#0a1628" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    Telnyx
  </span>
);

export default TelnyxBadge;
